var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment');
var Point = require('../models/point');
var buttonElement = require('../../components/button');
var calibrateModal = require('./calibrateModal');
var confirmationModal = require('./calibrationEnableModal')
var downloadCalibrationReport = require('./downloadCalibrationReport');
var loaders = require('../../layout/components/loaders');
var dateFormat = 'dddd MMMM D YYYY';

var alerts = require('../../layout/components/alerts'); 

module.exports = {
  oninit: function (vnode) {
    var ctrl = this;
    ctrl.parentCtrl = vnode.attrs.parentCtrl;
    ctrl.init = function () {
      if (ctrl.parentCtrl.point().asset) {
        loaders.requestWithLoader({
          url: "/api/v1/asset/"+ctrl.parentCtrl.point().asset['@rid'].slice(1) + "/actions",
          method: "GET",
          loader: 'background'
        })
        .then(function(assetResponse) {
          ctrl.actions = assetResponse;
          if (Array.isArray(ctrl.actions) && ctrl.actions.length > 0) {      
            return loaders.requestWithLoader({
              url: "/api/v1/user/" + ctrl.actions[ctrl.actions.length - 1].performedBy.slice(1),
              method: "GET",
              loader: 'background'
            })
            .then(function (userRecord) {
              ctrl.lastCalibrationUser = userRecord
            })
          }
        })
        .catch(function (e) {
          alerts.vm.add({detail: '' + e})
          console.log(e)
        })
      }
    }
    ctrl.init();
  },
  view: function () {
    var ctrl = this;
    if (Array.isArray(ctrl.actions) && ctrl.actions.length > 0) {
      var calibrationDate = new Date(ctrl.parentCtrl.point().asset.lastAction);
      var nextCalibrationDate = new Date(calibrationDate);
      var lastOffset = ctrl.actions[ctrl.actions.length - 1].offset;
      nextCalibrationDate.setFullYear(calibrationDate.getFullYear() + 1);
    }
    if (!ctrl.parentCtrl.point().asset) {
      return m('div', [
        m('fr', [
          m(buttonElement, {
            label: 'Begin calibration tracking',
            func: confirmationModal.editDialogue.bind(confirmationModal, {
              point: (ctrl.parentCtrl.point() && ctrl.parentCtrl.point()['@rid']) || Point.record['@rid']
            }),
            class: 'w5 fr mt2'
          })
        ])
      ]);
    }

    return m('div', [
      m('div.flex.justify-between.items-center.bb.bw1.pr3', [
        m("p", "Next Calibration: "),
        (function () {
          if (ctrl.parentCtrl.point().asset.lastAction) {
            return m("p", moment(nextCalibrationDate).format(dateFormat))
          } else {
            return m("p",'Pending')
          }
        })()
      ]),
      m('div.flex.justify-between.items-center.bb.bw1.pr3', [
        m("p", "Last Calibrated: "),
        (function () {
          if (ctrl.parentCtrl.point().asset.lastAction) {
            return m("p", moment(ctrl.parentCtrl.point().asset.lastAction).format(dateFormat))
            
          } else {
            return m("p",'Never')
          }
        })() 
      ]),
      m('div.flex.justify-between.items-center.bb.bw1.pr3', [
        m("p", "Calibrated By: "),
        m("p", `${ctrl.lastCalibrationUser && ctrl.lastCalibrationUser.firstName && ctrl.lastCalibrationUser.lastName ? `${ctrl.lastCalibrationUser.firstName} ${ctrl.lastCalibrationUser.lastName}` : ''}`),
      ]),
      m('div.flex.justify-between.items-center.bb.bw1.pr3', [
        m("p", "Reference Instrument: "),
        m("p", (() => {
          const asset = ctrl.parentCtrl.point().asset;
          const inPerformedOn = asset?.in_performedOn;
          const latest = inPerformedOn?.[inPerformedOn.length - 1];
          return latest?.out?.in_usedFor?.[0]?.out?.name || '';
        })())
      ]),
      m('div.flex.justify-between.items-center.bw1.pr3', [
        m('div.flex.justify-end.w-30', [
          m(buttonElement, {
            label: 'Edit',
            func: confirmationModal.editDialogue.bind(confirmationModal, ctrl.parentCtrl.point().asset, {submitCallback: ctrl.init}),
            class: 'fr mv2 w-100 blue'
          })
        ]),
        m('div.flex.justify-end.w-30', [
          m(buttonElement, {
            label: 'Start Calibration',
            func: calibrateModal.editDialogue.bind(calibrateModal, Point.record, {submitCallback: ctrl.init, lastOffset}),
            class: 'fr mv2 w-100 blue'
          })
        ]),
        m('div.flex.justify-end.w-30', [
          ctrl.actions && ctrl.actions.length > 0 ? 
            m(buttonElement, {
              label: 'Download',
              func: function () {
                return downloadCalibrationReport(ctrl.parentCtrl.point().asset['@rid']);
              },
              class: 'fr mv2 w-100 green'
            })
          : ''
        ])
      ]),
    ]);
  }
}
